<template>
    <div id="app">
      <router-view></router-view>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'App',
    computed: {
      ...mapState(['token'])
    },
    mounted() {
      // Check if user is logged in when the component is mounted
      if (!this.token) {
        // Perform actions like redirecting to login page, etc.
        this.$router.push('/login');
      }
    }
  };
  </script>

  <style>
  .table {
    width: 100%;
    border-collapse: collapse;
  }

  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  .table th {
    background-color: #d6cd98;
  }

  .success {
    color: green;
  }

  .error {
    color: red;
  }
  </style>
